export const defaultPrecisionValue = 3;

export const precision = (
  value: number,
  digits: number = defaultPrecisionValue,
): number => +value.toFixed(digits);
